'use strict';
module.exports = [
  require('./mad'),
  require('./max'),
  require('./mean'),
  require('./median'),
  require('./min'),
  require('./mode'),
  require('./prod'),
  require('./quantileSeq'),
  require('./std'),
  require('./sum'),
  require('./var')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/statistics/index.js
// module id = 1837
// module chunks = 0